import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../layout/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { ModalHeaderComponent } from '../../modals/modal-header/modal-header.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { TabGroupComponent } from '../../tab-group/tab-group.component';
import { TabComponent } from '../../tab/tab.component';

import { CustomCheckboxComponent } from '../../custom-checkbox/custom-checkbox.component';
import { DutchDateTimePipe } from '../../../pipes/dutch-date-time.pipe';
import { SlugifyPipe } from '../../../pipes/slugify/slugify.pipe';

@Component({
  selector: 'app-client-form',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ModalHeaderComponent,
    LoaderComponent,
    DutchDateTimePipe,
    SlugifyPipe,
    TabGroupComponent,
    TabComponent,
    CustomCheckboxComponent
  ],
  templateUrl: './client-form.component.html',
  styleUrl: './client-form.component.scss'
})
export class ClientFormComponent implements OnInit {

  _item: any = {};
  @Input()
  set item(value: any) {
    this._item = value;
    this.onItemSet(value);
  }

  get item() {
    return this._item;
  }

  onItemSet(item: any) {
    if (this.item['id']) {
      this.modalTitle = 'Wijzig app';
    } else {
      this.modalTitle = 'App toevoegen';
    }
  }

  getObjKeys(obj: any) {
    return Object.keys(obj)
  }

  @Input() modalInstance: any = null;

  modalTitle: string = 'App toevoegen';
  refreshExternalTokenMessage: string = '';
  errorMessage: any = {};
  errors: any = {};
  loading: boolean = false;
  modalStyle: boolean = false;
  serviceProviderOptions: string[] = ['NEO', 'EDU-V', 'IPSKAMP'];

  user: any;
  scopes: [] = [];
  selectedScopes: any = {};

  constructor(
    private apiService: ApiService,
    public activeModal: NgbActiveModal
  ) {
    this.item = {};
  }

  ngOnInit() {
    this.loading = true;

    this.errorMessage = {};
    this.errors = {};
    this.getItem();
    this.getScopes();
  }

  afterSave() {
    this.activeModal.close(true);
  }

  toggleScope(scope: string): void {
    console.dir(scope);
    // if (this.selectedScopes.includes(scope)) {
    // this.selectedScopes = this.selectedScopes.filter((s: any) => s !== scope);
    // } else {
    // this.selectedScopes.push(scope);
    // }
    // console.dir(this.selectedScopes);
  }

  getUser() {
    let self = this;

    return this.apiService.get('/office/users/' + self.item['user_id']).then(function (response: any) {
      self.user = response;

      let scopes = self.user.scopes || "";
      scopes = JSON.parse(scopes);

      self.scopes.forEach(function (value) {
        console.log(value);
        if (scopes.includes(value)) {
          self.selectedScopes[value] = true;
        } else {
          self.selectedScopes[value] = false;
        }
      });

      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }

  save() {
    let self = this;

    self.reset();
    self.loading = true;

    const modal = document.querySelector('.modal');
    if (modal) {
      modal.scrollTo({ top: 0, behavior: 'smooth' });
    }

    let postData = this.item;
    postData['scopes'] = this.selectedScopes;

    if (!this.item['id'] || this.item['id'] === '') {
      return this.apiService.post('/office/clients', postData).then(function (response: any) {
        self.handleSucces(response);
      }).catch(function (e) {
        self.handleError(e);
      });
    }
    else {
      return this.apiService.put('/office/clients/' + this.item['id'], postData).then(function (response: any) {
        self.handleSucces(response);
      }).catch(function (e) {
        self.handleError(e);
      });
    }
  }

  handleSucces(response: any) {
    let self = this;
    self.item = response;
    self.afterSave();
    setTimeout(function () {
      self.loading = false;
    }, 200);
  }

  handleError(response: any) {
    let self = this;
    self.errors = response['error']['error'];
    self.errorMessage = response['error']['message'];
    self.loading = false;

    if (response.status == 500) {
      self.errorMessage = response['error']['message'];
      self.errors = [];
    }
  }

  reset() {
    this.errors = {};
    this.errorMessage = '';
  }

  refreshExternalToken() {
    let self = this;
    self.loading = true;
    self.refreshExternalTokenMessage = '';
    return this.apiService.get('/office/clients/' + self.item['id'] + '/refresh-external-token').then(function (response: any) {
      self.refreshExternalTokenMessage = response['message'];
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }

  getItem() {
    let itemId = this.item['id'];
    let self = this;

    self.reset();
    if (itemId === '') {
      return;
    }
    return this.apiService.get('/office/clients/' + itemId).then(function (response: any) {
      self.item = response;
      if (self.item['id']) {
        self.modalTitle = 'Wijzig app';
        self.getUser();
      } else {
        self.modalTitle = 'App toevoegen';
      }
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }

  getScopes() {
    let self = this;
    return this.apiService.get('/office/users/scopes').then(function (response: any) {
      self.scopes = response['edu_v'];
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }
}
